import {
  DESKTOP_GRID_SIZE,
  DEVICES,
  MOBILE_GRID_SIZE,
  TABLET_HORIZONTAL_GRID_SIZE,
  TABLET_VERTICAL_GRID_SIZE
} from './devices'
import { SIZE_LARGE, SIZE_MEDIUM } from './size'

export const MAX_COLUMNS = 2

// export const QUESTION_SIZE_SM = 'sm'
// export const QUESTION_SIZE_SM_GRID_COUNT = 4
export const QUESTION_SIZE_MD = SIZE_MEDIUM
export const QUESTION_SIZE_MD_GRID_COUNT = 6
export const QUESTION_SIZE_LG = SIZE_LARGE
export const QUESTION_SIZE_LG_GRID_COUNT = 12

export const QUESTION_SIZE_GRID_COUNTS = [
  // QUESTION_SIZE_SM_GRID_COUNT,
  QUESTION_SIZE_MD_GRID_COUNT,
  QUESTION_SIZE_LG_GRID_COUNT
]

export const QUESTION_GRID_TO_SIZE_MAP = {
  // [QUESTION_SIZE_SM_GRID_COUNT]: QUESTION_SIZE_SM,
  [QUESTION_SIZE_MD_GRID_COUNT]: QUESTION_SIZE_MD,
  [QUESTION_SIZE_LG_GRID_COUNT]: QUESTION_SIZE_LG
}

export const QUESTION_DEVICE_GRID_SIZE_MAP = {
  [DEVICES.DESKTOP]: {
    // [QUESTION_SIZE_SM]: QUESTION_SIZE_SM_GRID_COUNT,
    [QUESTION_SIZE_MD]: {
      [DESKTOP_GRID_SIZE]: QUESTION_SIZE_MD_GRID_COUNT
    },
    [QUESTION_SIZE_LG]: {
      [DESKTOP_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT
    }
  },
  [DEVICES.TABLET]: {
    // [QUESTION_SIZE_SM]: QUESTION_SIZE_MD_GRID_COUNT,
    [QUESTION_SIZE_MD]: {
      [TABLET_VERTICAL_GRID_SIZE]: QUESTION_SIZE_MD_GRID_COUNT
    },
    [QUESTION_SIZE_LG]: {
      [TABLET_VERTICAL_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT
    }
  },
  [DEVICES.MOBILE]: {
    // [QUESTION_SIZE_SM]: QUESTION_SIZE_LG_GRID_COUNT,
    [QUESTION_SIZE_MD]: {
      [MOBILE_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT
    },
    [QUESTION_SIZE_LG]: {
      [MOBILE_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT
    }
  }
}

export const QUESTION_RESPONSIVE_GRID_SIZE_MAP = {
  [QUESTION_SIZE_MD]: {
    [DESKTOP_GRID_SIZE]: QUESTION_SIZE_MD_GRID_COUNT,
    [TABLET_HORIZONTAL_GRID_SIZE]: QUESTION_SIZE_MD_GRID_COUNT,
    [TABLET_VERTICAL_GRID_SIZE]: QUESTION_SIZE_MD_GRID_COUNT,
    [MOBILE_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT
  },
  [QUESTION_SIZE_LG]: {
    [DESKTOP_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT,
    [TABLET_HORIZONTAL_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT,
    [TABLET_VERTICAL_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT,
    [MOBILE_GRID_SIZE]: QUESTION_SIZE_LG_GRID_COUNT
  }
}
